import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParametrosService {

  private API = environment.API

constructor(private http: HttpClient) {
  environment.emitAPI.subscribe(api => {
    this.API = api
  })
}

getParametros() {
  return this.http.get(`${this.API}ParametrosSistema/GetParametros`)
}

getParametro(parametro){
  return this.http.get<any>(`${this.API}ParametrosSistema/GetParametro/${parametro}`)
}

postParametros(parametros) {
  return this.http.post(`${this.API}ParametrosSistema`, parametros)
}

getValoresParametrosContrato() {
  return this.http.get<any>(`${this.API}ParametrosSistema/GetParametro/ValoresIdsContrato`)
}

}
